module.exports = __webpack_public_path__ + "static/media/tour-timer-img.3074a99b.svg";